import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { permissionDtoSchema } from '../schemas/roleSchemas';
import { roleKeys } from './roleKeys';

export function useListPermissions() {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: roleKeys.permissions(),
    queryFn: async ({ signal }) => {
      const raw = await apiClient.get(`api/v1/t/${tenantId}/roles/permissions`, { signal }).json();
      return z.array(permissionDtoSchema).parse(raw);
    },
    enabled: !!tenantId,
    staleTime: 5 * 60_000,
  });
}
